import Plot from 'react-plotly.js'
import Plotly from 'plotly.js/dist/plotly'
import PropTypes from 'prop-types'
import React from 'react'

class SaxsSimplePlot extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      curves: null,
      config: {
        responsive: true,
        autosizable: true,
      },
    }

    this.getCurves = this.getCurves.bind(this)
    this.onAutoSize = this.onAutoSize.bind(this)
  }

  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    let xaxis = nextProps.selectedAbscissa

    switch (nextProps.selectedAbscissa) {
      case 'frame':
        xaxis = 'Frame'
        break
      case 'volume':
        xaxis = 'Volume (mL)'
        break
      case 'time':
        xaxis = 'Time (s)'
    }

    this.setState({
      layout: {
        title: 'HPLC',
        xaxis: { title: xaxis },
        yaxis: { title: 'Intensity' },
        autosize: true,
      },
      curves: this.getCurves(nextProps.dataSeries),
    })
  }

  shouldComponentUpdate() {
    return true
  }

  componentDidMount() {
    let xaxis = this.props.selectedAbscissa

    switch (this.props.selectedAbscissa) {
      case 'frame':
        xaxis = 'Frame '
        break
      case 'volume':
        xaxis = 'Volume (mL)'
        break
      case 'time':
        xaxis = 'Time (s)'
    }

    this.setState({
      layout: this.props.layout
        ? this.props.layout
        : {
            title: 'HPLC',
            xaxis: { title: xaxis },
            yaxis: { title: 'Intensity' },
            autosize: true,
          },
      curves: this.getCurves(this.props.dataSeries),
    })
  }

  render() {
    return (
      this.props.dataSeries &&
      this.state.curves && (
        <Plot
          divId={this.props.divId}
          data={this.state.curves}
          layout={this.state.layout}
          config={this.state.config}
          useResizeHandler
          onAutoSize={this.onAutoSize}
          onClick={this.props.onPlotPointClicked}
          onRelayout={this.props.onPlotRelayout}
          onInitialized={this.props.onPlotInitialized}
          onUpdate={this.updateHandler}
        />
      )
    )
  }

  getCurves(dataSeries) {
    const curves = []

    if (dataSeries) {
      dataSeries.forEach(dataSerie => {
        curves.push({
          x: dataSerie.values.x,
          y: dataSerie.values.y,
          type: 'scatter',
          mode: 'lines',
          name: dataSerie.label,

          line: {
            color: dataSerie.isAStdDevDataSerie === true ? 'rgba(255,255,255,0)' : dataSerie.color,
          },

          connectgaps: false,
          fill: dataSerie.isAStdDevDataSerie === true ? 'tozeroy' : 'none',
          fillcolor: dataSerie.isAStdDevDataSerie === true ? 'rgba(255,0,255,0.2)' : null,
          showlegend: dataSerie.isAStdDevDataSerie !== true,
          hoverinfo: dataSerie.isAStdDevDataSerie === true ? 'none' : 'all',
        })
      })
    }

    return curves
  }

  onAutoSize() {
    const graphElement = document.getElementById(this.props.divId)
    if (graphElement) {
      this.height = graphElement.parentNode.offsetHeight
      this.width = graphElement.parentNode.offsetWidth - 30
      Plotly.relayout(this.props.divId, {
        width: this.width,
        height: 400,
      })
    }
  }
}

export default SaxsSimplePlot

SaxsSimplePlot.propTypes = {
  dataSeries: PropTypes.array,
  divId: PropTypes.string.isRequired,
  layout: PropTypes.object,
  onPlotPointClicked: PropTypes.func,
}
